import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class CourseDetailAPI extends BaseAPI {}

export default new CourseDetailAPI('v1/course-detail', 'CourseDetail')
